import { useMount } from "react-use";
import { page } from "@src/utils/segment";

export const usePageTracking = (pageName: string, pageProperties?: Record<string, unknown>) => {
  useMount(() => {
    page(pageName, pageProperties);
  });
};
